module.exports = __webpack_public_path__ + "img/logo-boires-small.1b6b9665.png";